import { z } from 'zod';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#response-format

	201 CREATED
	{
		"antragsteller1": {
			"id": String
		},
		"antragsteller2": {
			"id": String
		},
		"vorgangsnummer": String,
		"messages": [ String ]
	}

*/

const schemaAntragsteller = z
    .object({
        id: z.string().min(1),
    })
    .nonstrict()
    .passthrough();

export const schemaCreateProcess = z.object({
    antragsteller1: schemaAntragsteller,
    antragsteller2: z.optional(schemaAntragsteller),
    messages: z.optional(z.array(z.string())),
    vorgangsnummer: z.string().min(1),
});

export type SchemaEuropaceCreateProcess = z.infer<typeof schemaCreateProcess>;
